import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import "./CostBenefits.css";

function CostBenefits() {
  return (
    <section>
      <div className="container">
        <div className="cost-benefits">
          <Link to="/signup/" className="cost-benefit-card">
            <div className="cost-benefits-content">
              <div>
                <StaticImage
                  src="../../images/ps-logo-subtitle.png"
                  alt="ProblemScape"
                  width={165}
                  placeholder="none"
                />
              </div>
              <div>Adventure game, Videos, Practice</div>
              <div className="plus-item">
                plus <b>Coming July 2025:</b>
              </div>
              <div>
                {" "}
                Web portal with extra practice, videos, challenge mini-games,
                and reviews.
              </div>
            </div>
            <ol className="cost-items">
              <li>
                <strong
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    marginRight: "1.4rem",
                  }}
                >
                  $48
                </strong>
                <div>
                  <span style={{ fontSize: "1.3rem" }}>
                    40% Off - Introductory Offer
                    <br />
                    Only $4/month!
                  </span>
                  <span style={{ fontSize: "1.2rem", color: "#000" }}>
                    {" "}
                    (Until July 31)
                  </span>
                </div>
              </li>
              <li>
                <strong
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    marginRight: "1.4rem",
                  }}
                >
                  <s>$80</s>
                </strong>
                <div>
                  <span style={{ fontSize: "1.4rem" }}>
                    Access for one year
                  </span>
                </div>
              </li>
            </ol>
          </Link>
          <ol>
            <li>
              <div className="cost-benefit-num">1</div>
              <div className="cost-benefit-text">
                Aligned with your state’s math content standards.
              </div>
            </li>
            <li>
              <div className="cost-benefit-num">2</div>
              <div className="cost-benefit-text">
                Seemless integration of math with game narrative.
              </div>
            </li>
            <li>
              <div className="cost-benefit-num">3</div>
              <div className="cost-benefit-text">
                Designed for self-paced learning.
              </div>
            </li>
            <li>
              <div className="cost-benefit-num">4</div>
              <div className="cost-benefit-text">
                Cross-platform (Tablets, Chromebooks, PC)
              </div>
            </li>
            <li>
              <div className="cost-benefit-num">5</div>
              <div className="cost-benefit-text">
                Research-backed (NSF-funded)
              </div>
            </li>
          </ol>
        </div>
      </div>
    </section>
  );
}

export default CostBenefits;
